<template>
    <div>
        <h2 class="def-header-2">{{result.message.title}}</h2>
        <div  v-if="getScreenWidth() >= 992" class="def-slider-owl">
            <span @click="slidePrev()" class="def-slider-owl__arrow">
                <svg>
                    <use xlink:href="#svg-arrow-left"></use>
                </svg>
            </span>
            <VOwlCarousel2  v-bind="settings" ref="VOwlCarousel2">
                <choice-ring-card v-for="item in result.items" :key="item.id" :result="item" />
            </VOwlCarousel2>
            <span @click="slideNext()" class="def-slider-owl__arrow def-slider-owl__arrow_right">
                <svg>
                    <use xlink:href="#svg-arrow-right"></use>
                </svg>
            </span>
        </div>

        <PerfectScrollbar v-else class="def-slider__mobile">
            <choice-ring-card v-for="item in result.items" :key="item.id" :result="item" />
        </PerfectScrollbar>
        <div class="new-goods__bottom">
            <a v-if="result.link" :href="result.link.href" class="def-button">{{result.link.name}}</a>
        </div>
    </div>
</template>

<script>
export default {
    name: 'choice-ring',
    selector: '.choice-ring',
    props: {
        result: {
            type: Object,
            default: () => ({
                "message":{"title":"Обирайте каблучки  в Love you"},
                "items":[
                    {
                        "name":"весілля",
                        "text":"3 890 обручок",
                        "detailPage":"/blog/test-2/",
                        "picture": {
                            "alt":"Test 2",
                            "src":"/local/templates/love-you/images/front-end/blog/blog-6.png"
                        }
                    },
                    {
                        "name":"весілля",
                        "text":"3 890 обручок",
                        "detailPage":"/blog/test-2/",
                        "picture": {
                            "alt":"Test 2",
                            "src":"/local/templates/love-you/images/front-end/blog/blog-6.png"
                        }
                    },
                    {
                        "name":"весілля",
                        "text":"3 890 обручок",
                        "detailPage":"/blog/test-2/",
                        "picture": {
                            "alt":"Test 2",
                            "src":"/local/templates/love-you/images/front-end/blog/blog-6.png"
                        }
                    }
                ],
                "link": {
                    "href":"javascript:void(0)",
                    "name":"до каталогу каблучок"
                }
            })
        }
    },
    data() {
        return {
            settings: {
                items: 3,
                margin: 40,
                nav: false,
            }
        }
    },
    methods: {
        slidePrev() {
            if (this.$refs.VOwlCarousel2.showPrev) {
                this.$refs.VOwlCarousel2.owl.trigger('next.owl.carousel');
            }
        },
        slideNext() {
            if (this.$refs.VOwlCarousel2.showNext) {
                this.$refs.VOwlCarousel2.owl.trigger('next.owl.carousel');
            }
        },
        getScreenWidth() {
            return window.innerWidth;
        },
    }
}
</script>

<style lang="scss">
    //.new-goods{
    //    margin: 104px 0;
    //    &__bottom{
    //        display: flex;
    //        align-items: center;
    //        justify-content: center;
    //        margin-top: 10px;
    //    }
    //    .def-button{
    //        font-size: rem(14);
    //        text-transform: uppercase;
    //        height: 48px;
    //        @include point-lg{
    //            height: 56px;
    //            font-size: rem(18);
    //            padding: 0 48px;
    //        }
    //    }
    //}
</style>